module.exports = __webpack_public_path__ + "static/media/Hull colour - pastel blue RAL 9010 & 3 x pure white RAL 9010 waterlines.7ee8daa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/Hull colour - pastel blue RAL 9010 & 3 x pure white RAL 9010 waterlines.jpg
// module id = 119
// module chunks = 0